/**
 * 
 * This is a file to create default data store. default data store contains all the states that are needed
 * for dev center operations
 */
import { createStore } from 'redux';
import reducers from '../app/combine-reducers';

let devCenterStore = "";

// create dev center data store if not exist
function createDevCenterDataStoreIfNotExist()
{
    // if devcenterstore does not exist create it
    if(devCenterStore == "")
    {
        devCenterStore = createStore(reducers);
    }
}

// This is the method to get devcenter data store
function getDevCenterDataStore()
{
    if(devCenterStore == "")
    {
        createDevCenterDataStoreIfNotExist();
    }
    return devCenterStore;
}

// This is a method to initiate dispatch event and store the data into dev center data store
function putDataInDevCenterDataStore(payload)
{
    getDevCenterDataStore().dispatch(payload);  
}

export default createDevCenterDataStoreIfNotExist;
export {getDevCenterDataStore,putDataInDevCenterDataStore}; 